import { observable, action, computed, runInAction } from 'mobx'
import api from '../api'

class InstaRegistrationStore {
  @observable email = ''
  @observable firstname = ''
  @observable lastname = ''
  @observable dateOfBirth = ''
  @observable phone = ''
  @observable phoneType = 'fixed'
  @observable street = ''
  @observable city = ''
  @observable postcode = ''
  @observable password = ''
  @observable passwordRepeat = ''
  @observable code = ''
  @observable gtc = false
  @observable error = undefined
  @observable passwordMessage = 'home_register_password_explanation'
  @observable passwordDefaultMessage = 'home_register_password_explanation'
  @observable codeMessage = ''
  @observable easyplusCode = ''
  @observable easyplusCodeAccepted

  @action.bound setEmail(email) {
    this.email = email
  }

  @action.bound setFirstname(firstname) {
    this.firstname = firstname
  }

  @action.bound setLastname(lastname) {
    this.lastname = lastname
  }

  @action.bound setDateOfBirth(dateOfBirth) {
    this.dateOfBirth = dateOfBirth
  }

  @action.bound setStreet(street) {
    this.street = street
  }

  @action.bound setCity(city) {
    this.city = city
  }

  @action.bound setPostcode(postcode) {
    this.postcode = postcode
  } 

  @action.bound setPassword(password) {
    this.password = password
  }

  @action.bound setPasswordRepeat(passwordRepeat) {
    this.passwordRepeat = passwordRepeat
  }

  @action.bound setCode(code) {
    this.code = code
  }

  @action.bound setGtc(gtc) {
    this.gtc = gtc
  }

  @action.bound setPhone(phone) {
    this.phone = phone
  }

  @action.bound setPhoneType(phoneType) {
    this.phoneType = phoneType
  }

  @action.bound setPasswordMessage(passwordMessage) {
    this.passwordMessage = passwordMessage
  }

  @action.bound setEasyplusCode(easyplusCode) {
    this.easyplusCodeAccepted = false
    this.easyplusCode = easyplusCode
  }

  @action.bound resetMessages() {
    this.passwordMessage = this.passwordDefaultMessage
    this.codeMessage = ''
  }

  @action.bound setCodeMessage(codeMessage) {
    this.codeMessage = codeMessage
  }

  @action.bound setEasyplusCodeAccepted(accepted) {
    this.easyplusCodeAccepted = accepted
  }

  @computed get correctCode() {
    return this.easyplusCode === 'INSTA1'
  }

  @action.bound async sendRegistration() {
    const request = {
      'email': this.email,
      'firstname': this.firstname,
      'lastname': this.lastname,
      'password': this.password,
      'street': this.street,
      'dateOfBirth': this.dateOfBirth,
      'city': this.city,
      'postcode': this.postcode,
      'campaign': 'INSTA1',      
    }

    if(this.phoneType === 'mobile') {
      request.phoneMobile = this.phone
    } else {
      request.phoneFixed = this.phone
    }
    
    try {
      await api.User.createCustomer(request)
      return false
    } catch(error) {
      this.error = error.response.message

      return this.error
    }
  }

  @action.bound reset() {
    this.email = ''
    this.firstname = ''
    this.lastname = ''
    this.password = ''
    this.passwordRepeat = ''
    this.code = ''
    this.easyplusCode = ''
    this.easyplusCodeAccepted = false
  }
}

export default new InstaRegistrationStore()



// WEBPACK FOOTER //
// ./src/stores/instaRegistrationStore.js